import { Injectable } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LeaveConfirmDialogComponent } from '../views/shared/leave-confirm-dialog/leave-confirm-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  openConfirmDialog(message: string): MatDialogRef<LeaveConfirmDialogComponent> {
    return this.dialog.open(LeaveConfirmDialogComponent, {
      data: { message },
      disableClose: true
    });
  }
}
